import { AnyAction } from "redux";
import { PersonalTabSettings } from "../../components/scenes/Layers/fields/useSwitchTab";
import { PATCH } from "./actionsTypes";

export interface User {
    preferences?: AllUserPreferences;
    is_admin?: boolean;
    tenant_user?: {
        facility?: string;
        roles?: string[];
        teams?: string[];
    };
    tenant: {
        tenant_id?: string;
        tenant_name?: string;
        has_two_fta?: boolean;
        uses_kg?: boolean;
    };
}

export interface AllUserPreferences {
    [tenant_id: string]: UserPreferences;
}

export interface UserPreferences {
    fruit_types?: string[] | null;
    facilities?: string[] | null;
    assigned_team?: string[] | null;
    ripening_field?: string | null;
    tabs?: {[tab: string]: PersonalTabSettings};
    group_by?: string[] | null;
}

const endpoint = "users/";

export function updatePreferences(data: AllUserPreferences) {
    return {
        types: [PATCH.LOADING, PATCH.SUCCESS, PATCH.ERROR],
        payload: {
            request: {
                method: "PATCH",
                url: `${endpoint}preferences/`,
                data,
            },
        },
    } as unknown as AnyAction;
}

export function updatePreferencesLocally(data: AllUserPreferences) {
    return {
        type: PATCH.SUCCESS,
        payload: { data: { preferences: data } },
    } as unknown as AnyAction;
}
